import Loc from "../../services/localization";
import { ref } from 'vue';

const LocService = new Loc()

export default{
    props: {
        selectedList: Array,
        show: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            locale: LocService,
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            selectedDates: [],
            weekdays: [
                LocService.t('day_monday_short'),
                LocService.t('day_tuesday_short'),
                LocService.t('day_wednesday_short'),
                LocService.t('day_thursday_short'),
                LocService.t('day_friday_short'),
                LocService.t('day_saturday_short'),
                LocService.t('day_sunday_short')
            ],
        };
    },
    created() {
        this.$emit('update:selectedList',  [])
    },
    computed: {
        currentMonthName() {
            return this.getMonthDisplay(this.currentMonth);
        },
        // daysInMonth() {
        //     let days = [];
        //
        //     let firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay() - 1;
        //     let totalDays = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
        //     console.log(firstDay)
        //     for (let i = 0; i < firstDay; i++) {
        //         days.push({ day: "", date: null });
        //     }
        //
        //     for (let i = 1; i <= totalDays; i++) {
        //         let date = `${i.toString().padStart(2, '0')}-${(this.currentMonth + 1).toString().padStart(2, '0')}-${this.currentYear}`;
        //         days.push({ day: i, date });
        //     }
        //     return days;
        // },

        daysInMonth() {
            let days = [];

            const jsDow = new Date(this.currentYear, this.currentMonth, 1).getDay();
            const firstDay = (jsDow + 6) % 7;

            const totalDays = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();

            for (let i = 0; i < firstDay; i++) {
                days.push({ day: "", date: null });
            }

            for (let i = 1; i <= totalDays; i++) {
                let date = `${i.toString().padStart(2, '0')}-${(this.currentMonth + 1).toString().padStart(2, '0')}-${this.currentYear}`;
                days.push({ day: i, date });
            }

            return days;
        }
    },


    methods: {
        prevMonth() {
            if (this.currentMonth === 0) {
                this.currentMonth = 11;
                this.currentYear--;
            } else {
                this.currentMonth--;
            }
        },
        nextMonth() {
            if (this.currentMonth === 11) {
                this.currentMonth = 0;
                this.currentYear++;
            } else {
                this.currentMonth++;
            }
        },
        toggleDate(date) {
            if (!date) return;
            const index = this.selectedDates.indexOf(date);
            if (index === -1) {
                this.selectedDates.push(date);
            } else {
                this.selectedDates.splice(index, 1);
            }
            this.$emit('update:selectedList',  this.selectedDates)
        },
        reset(){
            this.selectedDates = [];
            this.$emit('update:selectedList',  this.selectedDates)
        },
        getMonthDisplay: getMonthDisplay
    },

    watch: {
        show: function (val, oldVal) {
            if (val) {
               this.selectedDates = [];
            }
        },
    },
}

function getMonthDisplay(month) {
    switch (month + 1) {
        case 1: return this.locale.t("month_january");
        case 2: return this.locale.t("month_february");
        case 3: return this.locale.t("month_march");
        case 4: return this.locale.t("month_april");
        case 5: return this.locale.t("month_may");
        case 6: return this.locale.t("month_june");
        case 7: return this.locale.t("month_july");
        case 8: return this.locale.t("month_august");
        case 9: return this.locale.t("month_september");
        case 10: return this.locale.t("month_october");
        case 11: return this.locale.t("month_november");
        case 12: return this.locale.t("month_december");
        default: return this.locale.t("month_january");
    }
}



// WEBPACK FOOTER //
// ./src/components/Shared/CustomCalendar.js